
import React from 'react';
import { cn } from '@/lib/utils';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import LogoProcessor from './LogoProcessor';

const Header = () => {
  const [scrolled, setScrolled] = React.useState(false);
  const navigate = useNavigate();
  
  React.useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <header 
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 py-4",
        scrolled ? "bg-white/95 backdrop-blur-sm shadow-sm" : "bg-transparent"
      )}
    >
      <div className="container mx-auto flex items-center justify-between">
        <LogoProcessor />
        <div className="flex items-center gap-3">
          <a 
            href="https://apps.apple.com/us/app/countedcare/id6757411837" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hidden sm:block hover:opacity-80 transition-opacity duration-200"
          >
            <img src="/images/app-store-badge.svg" alt="Download on the App Store" className="h-9" />
          </a>
          <a 
            href="https://play.google.com/store/apps/details?id=com.countedcare.countedcare&hl=en" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hidden sm:block hover:opacity-80 transition-opacity duration-200"
          >
            <img src="/images/google-play-badge.png" alt="Get it on Google Play" className="h-9" />
          </a>
          <Button 
            className="bg-sky-600 hover:bg-sky-700 text-white hover-scale transition-all duration-200"
            onClick={() => window.open('https://app.countedcare.com/', '_blank')}
          >
            Start Tracking
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
